import { render, staticRenderFns } from "./comisionesPagadas.vue?vue&type=template&id=13a93246&scoped=true"
import script from "./comisionesPagadas.vue?vue&type=script&lang=js"
export * from "./comisionesPagadas.vue?vue&type=script&lang=js"
import style0 from "./comisionesPagadas.vue?vue&type=style&index=0&id=13a93246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a93246",
  null
  
)

export default component.exports